import { api } from '../lib/api';

export interface Integration {
  id: string;
  workspaceId: string;
  name: string;
  type: 'google_sheets' | 'google_calendar' | 'rest_api';
  config: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

export interface CreateIntegrationPayload {
  name: string;
  type: 'google_sheets' | 'google_calendar' | 'rest_api';
  config: Record<string, any>;
}

export interface UpdateIntegrationPayload {
  name?: string;
  config?: Record<string, any>;
}

export const integrationsApi = {
  getAll: async (workspaceId: string): Promise<Integration[]> => {
    const response = await api.get(`/workspaces/${workspaceId}/integrations`);
    return response.data;
  },

  getOne: async (workspaceId: string, id: string): Promise<Integration> => {
    const response = await api.get(`/workspaces/${workspaceId}/integrations/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: CreateIntegrationPayload): Promise<Integration> => {
    const response = await api.post(`/workspaces/${workspaceId}/integrations`, data);
    return response.data;
  },

  update: async (
    workspaceId: string,
    id: string,
    data: UpdateIntegrationPayload,
  ): Promise<Integration> => {
    const response = await api.patch(`/workspaces/${workspaceId}/integrations/${id}`, data);
    return response.data;
  },

  remove: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/integrations/${id}`);
  },

  fetchRestApi: async (workspaceId: string, id: string): Promise<unknown> => {
    const response = await api.get(`/workspaces/${workspaceId}/integrations/${id}/fetch`);
    return response.data;
  },
};
